import { CALLING_COUNTRY_CODES } from "@wix/form-validator";
import localeDataset from "@wix/locale-dataset-javascript";
import parsePhoneNumber, { isValidPhoneNumber, AsYouType } from "libphonenumber-js";
import Metadata from "libphonenumber-js/metadata.min.json";
const PHONE_PREFIX = "+";
function parseCountryCodeFromPhoneNumber(phoneNumber) {
  const parsedNumber = phoneNumber ? parsePhoneNumber(phoneNumber) : void 0;
  const parsedCountryCode = parsedNumber?.country;
  if (parsedCountryCode) {
    return parsedCountryCode;
  }
  const asYouType = new AsYouType();
  phoneNumber && asYouType.input(phoneNumber);
  const guessedCountryCode = asYouType.getCountry();
  return guessedCountryCode;
}
function parseCountryCodeFromCallingCode(callingCode) {
  const countryByCallingCode = getCountryCodeByCallingCode(callingCode);
  return countryByCallingCode;
}
function toLongCountryCode(shortCountryCode) {
  return shortCountryCode ? CALLING_COUNTRY_CODES[shortCountryCode] : void 0;
}
function getCallingCode(countryCode) {
  return countryCode && localeDataset.getCountryByKey(countryCode)?.dialCode;
}
function getCountryCodeByCallingCode(phoneNumber) {
  phoneNumber = phoneNumber.trim();
  if (!phoneNumber.startsWith(PHONE_PREFIX)) {
    return void 0;
  }
  const withoutPrefix = phoneNumber.replace(/^\+/, "");
  const oneCharCode = withoutPrefix.substring(0, 1);
  const twoCharCode = withoutPrefix.substring(0, 2);
  const threeCharCode = withoutPrefix.substring(0, 3);
  const fourCharCode = withoutPrefix.substring(0, 4);
  const country = Metadata.country_calling_codes[fourCharCode]?.[0] || Metadata.country_calling_codes[threeCharCode]?.[0] || Metadata.country_calling_codes[twoCharCode]?.[0] || Metadata.country_calling_codes[oneCharCode]?.[0];
  return country;
}
function parseLocalPhone(value, country) {
  if (value && country) {
    try {
      const phoneNumber = parsePhoneNumber(value, country);
      const formattedPhoneNumber = phoneNumber?.formatInternational();
      if (formattedPhoneNumber && isValidPhoneNumber(formattedPhoneNumber)) {
        return formattedPhoneNumber.replace(/\s+/g, "");
      }
    } catch (e) {
    }
  }
  return value;
}
export {
  PHONE_PREFIX,
  getCallingCode,
  parseCountryCodeFromCallingCode,
  parseCountryCodeFromPhoneNumber,
  parseLocalPhone,
  toLongCountryCode
};
//# sourceMappingURL=phone-input-utils.js.map
